import {
  Component,
  OnInit,
  Inject,
  ViewEncapsulation,
  ViewChild
} from "@angular/core";
import { MatTableDataSource, MatSort } from "@angular/material";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSnackBarRef
} from "@angular/material";
import { NgForm } from "@angular/forms";
import { Response } from "@angular/http";
import { RacesService } from "../raceServices/races.service";
import { AngularFireDatabase, AngularFireList } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute } from "@angular/router";
import { ThankYouComponent } from "./thankYou.component";

@Component({
  selector: "app-R1",
  templateUrl: "./start.component.html",
  styleUrls: ["./start.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class R1Component implements OnInit {
  displayedColumns = ["no", "number", "teamName", "name", "kartCategory", "paymentStatus"];
  entryList1: any;
  drivers: any;
  driversArr: any = [];
  currentMap: any = "";
  id: string;
  currentDetails: any;
  currentRaceDate: any;
  currentBtnStatus: any;
  moreInfo: boolean = true;
  home: any = "";

  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public dialog: MatDialog,
    private racesService: RacesService,
    private activated: ActivatedRoute
  ) {}

  openDialog(): void {
    if (this.currentBtnStatus.registration) {
      const dialogRef = this.dialog.open(Registration1, {
        width: "504px",
        data: this.id
      });
    } else {
      console.log("The registration is closed");
    }
  }
  openDialog200(): void {
    if (this.currentBtnStatus.registration) {
      const dialogRef = this.dialog.open(Registration200, {
        width: "504px",
        data: this.id
      });
    } else {
      console.log("The registration200 is closed");
    }
  }

  ngOnInit() {
    // capturing param from URL
    if (this.activated.snapshot.params.id) {
      this.id = this.activated.snapshot.params.id;
      this.moreInfo = false;
      this.getDetails();
    } else {
      this.racesService
        .getHomePage()
        .valueChanges()
        .subscribe(home => {
          this.id = String(home);
          this.getDetails();
        });
    }
  }
  getDetails() {
    this.racesService.getDrivers(this.id).subscribe(actions => {
      this.driversArr = [];
      actions.forEach(action => {
        this.driversArr.push(action.payload.val());
      });
      this.entryList1 = new MatTableDataSource(this.driversArr);
      if (this.entryList1) {
        this.entryList1.sort = this.sort;
      }
    });
    this.racesService
      .getRaceMap(this.id)
      .valueChanges()
      .subscribe(raceMap => {
        this.currentMap = raceMap;
      });
    this.racesService
      .getCircuitDetails(this.id)
      .valueChanges()
      .subscribe(circuitDetails => {
        this.currentDetails = circuitDetails;
      });
    this.racesService
      .getBtnStatus(this.id)
      .valueChanges()
      .subscribe(btnStatus => {
        this.currentBtnStatus = btnStatus;
      });
    this.racesService
      .getOneRaceDate("2022", this.id)
      .valueChanges()
      .subscribe(date => {
        this.currentRaceDate = date;
      });
  }
}

@Component({
  selector: "registration1",
  templateUrl: "registration1.html",
  styleUrls: ["./start.component.css"]
})
export class Registration1 {
  id: string;
  selectedNr: any;
  constructor(
    public dialogRef: MatDialogRef<Registration1>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private racesService: RacesService,
    public snackBar: MatSnackBar,
    private activated: ActivatedRoute
  ) {}
  openSnackBar() {
    this.snackBar.openFromComponent(ThankYouComponent, {
      duration: 7000
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onSubmit(form: NgForm) {
    this.racesService.storeDriver(form.value, this.data);
    this.openSnackBar();
    this.onNoClick();
  }
  onChange(par: number) {
    if (par <= 0) {
      this.selectedNr = "";
    }
  }
}
@Component({
  selector: "registration200",
  templateUrl: "registration200.html",
  styleUrls: ["./start.component.css"]
})
export class Registration200 {
  id: string;
  selectedNr: any;
  constructor(
    public dialogRef: MatDialogRef<Registration200>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private racesService: RacesService,
    public snackBar: MatSnackBar,
    private activated: ActivatedRoute // private ThankYouComponent: ThankYouComponent
  ) {}
  openSnackBar() {
    this.snackBar.openFromComponent(ThankYouComponent, {
      duration: 7000
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onSubmit(form: NgForm) {
    const formValueWithStatus = {
      ...form.value,
      paymentStatus: 'laukiama',
    }
    this.racesService.storeDriver(formValueWithStatus, this.data);
    this.openSnackBar();
    this.onNoClick();
  }
  onChange(par: number) {
    if (par <= 0) {
      this.selectedNr = "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/calendar/races/r1/r1.component.ts